import _get from "lodash/get";
import _noop from "lodash/noop";

var __rest = this && this.__rest || function (s, e) {
  var t = {};

  for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];

  if (s != null && typeof Object.getOwnPropertySymbols === "function") for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
    if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
  }
  return t;
};
/* eslint-disable max-len */


import React from 'react';
import cls from 'classnames';
import PropTypes from 'prop-types';
import { cssClasses, numbers } from '@douyinfe/semi-foundation/lib/es/popconfirm/constants';
import PopconfirmFoundation from '@douyinfe/semi-foundation/lib/es/popconfirm/popconfirmFoundation';
import { IconClose, IconAlertTriangle } from '@douyinfe/semi-icons';
import BaseComponent from '../_base/baseComponent';
import Popover from '../popover';
import Button from '../button';
import ConfigContext from '../configProvider/context';
import LocaleConsumer from '../locale/localeConsumer';
import '@douyinfe/semi-foundation/lib/es/popconfirm/popconfirm.css';
export default class Popconfirm extends BaseComponent {
  constructor(props) {
    super(props);

    this.handleCancel = e => this.foundation.handleCancel(e && e.nativeEvent);

    this.handleConfirm = e => this.foundation.handleConfirm(e && e.nativeEvent);

    this.handleVisibleChange = visible => this.foundation.handleVisibleChange(visible);

    this.handleClickOutSide = e => this.foundation.handleClickOutSide(e);

    this.stopImmediatePropagation = e => e && e.nativeEvent && e.nativeEvent.stopImmediatePropagation();

    this.state = {
      cancelLoading: false,
      confirmLoading: false,
      visible: props.defaultVisible || false
    };
    this.foundation = new PopconfirmFoundation(this.adapter);
  }

  static getDerivedStateFromProps(props, state) {
    const willUpdateStates = {};
    const {
      hasOwnProperty
    } = Object.prototype;

    if (hasOwnProperty.call(props, 'visible')) {
      willUpdateStates.visible = props.visible;
    }

    return willUpdateStates;
  }

  get adapter() {
    return Object.assign(Object.assign({}, super.adapter), {
      setVisible: visible => this.setState({
        visible
      }),
      updateConfirmLoading: loading => this.setState({
        confirmLoading: loading
      }),
      updateCancelLoading: loading => this.setState({
        cancelLoading: loading
      }),
      notifyConfirm: e => this.props.onConfirm(e),
      notifyCancel: e => this.props.onCancel(e),
      notifyVisibleChange: visible => this.props.onVisibleChange(visible),
      notifyClickOutSide: e => this.props.onClickOutSide(e)
    });
  }

  renderControls() {
    const {
      okText,
      cancelText,
      okType,
      cancelType,
      cancelButtonProps,
      okButtonProps
    } = this.props;
    const {
      cancelLoading,
      confirmLoading
    } = this.state;
    return /*#__PURE__*/React.createElement(LocaleConsumer, {
      componentName: "Popconfirm"
    }, (locale, localeCode) => /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(Button, Object.assign({
      type: cancelType,
      onClick: this.handleCancel,
      loading: cancelLoading
    }, cancelButtonProps), cancelText || _get(locale, 'cancel')), /*#__PURE__*/React.createElement(Button, Object.assign({
      type: okType,
      theme: "solid",
      onClick: this.handleConfirm,
      loading: confirmLoading
    }, okButtonProps), okText || _get(locale, 'confirm'))));
  }

  renderConfirmPopCard() {
    const {
      content,
      title,
      className,
      style,
      cancelType,
      icon,
      prefixCls
    } = this.props;
    const {
      direction
    } = this.context;
    const popCardCls = cls(prefixCls, className, {
      ["".concat(prefixCls, "-rtl")]: direction === 'rtl'
    });
    const showTitle = title !== null && typeof title !== 'undefined';
    const showContent = !(content === null || typeof content === 'undefined');
    return (
      /*#__PURE__*/
      // eslint-disable-next-line jsx-a11y/click-events-have-key-events, jsx-a11y/no-static-element-interactions
      React.createElement("div", {
        className: popCardCls,
        onClick: this.stopImmediatePropagation,
        style: style
      }, /*#__PURE__*/React.createElement("div", {
        className: "".concat(prefixCls, "-inner")
      }, /*#__PURE__*/React.createElement("div", {
        className: "".concat(prefixCls, "-header")
      }, /*#__PURE__*/React.createElement("i", {
        className: "".concat(prefixCls, "-header-icon"),
        "x-semi-prop": "icon"
      }, /*#__PURE__*/React.isValidElement(icon) ? icon : null), /*#__PURE__*/React.createElement("div", {
        className: "".concat(prefixCls, "-header-body")
      }, showTitle ? /*#__PURE__*/React.createElement("div", {
        className: "".concat(prefixCls, "-header-title"),
        "x-semi-prop": "title"
      }, title) : null), /*#__PURE__*/React.createElement(Button, {
        className: "".concat(prefixCls, "-btn-close"),
        icon: /*#__PURE__*/React.createElement(IconClose, null),
        size: "small",
        theme: 'borderless',
        type: cancelType,
        onClick: this.handleCancel
      })), showContent ? /*#__PURE__*/React.createElement("div", {
        className: "".concat(prefixCls, "-body"),
        "x-semi-prop": "content"
      }, content) : null, /*#__PURE__*/React.createElement("div", {
        className: "".concat(prefixCls, "-footer")
      }, this.renderControls())))
    );
  }

  render() {
    // rtl changes the default position
    const {
      direction
    } = this.context;
    const defaultPosition = direction === 'rtl' ? 'bottomRight' : 'bottomLeft';

    const _a = this.props,
          {
      className,
      prefixCls,
      disabled,
      children,
      style,
      position = defaultPosition
    } = _a,
          attrs = __rest(_a, ["className", "prefixCls", "disabled", "children", "style", "position"]);

    if (disabled) {
      return children;
    }

    const {
      visible
    } = this.state;
    const popContent = this.renderConfirmPopCard();
    const popProps = {
      onVisibleChange: this.handleVisibleChange,
      className: cssClasses.POPOVER,
      onClickOutSide: this.handleClickOutSide
    };

    if (this.isControlled('visible')) {
      popProps.trigger = 'custom';
    }

    return /*#__PURE__*/React.createElement(Popover, Object.assign({}, attrs, {
      content: popContent,
      visible: visible,
      position: position
    }, popProps), children);
  }

}
Popconfirm.contextType = ConfigContext;
Popconfirm.propTypes = {
  motion: PropTypes.oneOfType([PropTypes.bool, PropTypes.func, PropTypes.object]),
  disabled: PropTypes.bool,
  content: PropTypes.any,
  title: PropTypes.any,
  prefixCls: PropTypes.string,
  className: PropTypes.string,
  style: PropTypes.object,
  icon: PropTypes.oneOfType([PropTypes.string, PropTypes.node]),
  okText: PropTypes.string,
  okType: PropTypes.string,
  cancelText: PropTypes.string,
  cancelType: PropTypes.string,
  onCancel: PropTypes.func,
  onConfirm: PropTypes.func,
  onClickOutSide: PropTypes.func,
  onVisibleChange: PropTypes.func,
  visible: PropTypes.bool,
  defaultVisible: PropTypes.bool,
  okButtonProps: PropTypes.object,
  cancelButtonProps: PropTypes.object,
  stopPropagation: PropTypes.oneOfType([PropTypes.bool, PropTypes.string]),
  zIndex: PropTypes.number,
  // private
  trigger: PropTypes.string,
  position: PropTypes.string
};
Popconfirm.defaultProps = {
  stopPropagation: true,
  trigger: 'click',
  // position: 'bottomLeft',
  onVisibleChange: _noop,
  disabled: false,
  icon: /*#__PURE__*/React.createElement(IconAlertTriangle, {
    size: "extra-large"
  }),
  okType: 'primary',
  cancelType: 'tertiary',
  prefixCls: cssClasses.PREFIX,
  zIndex: numbers.DEFAULT_Z_INDEX,
  onCancel: _noop,
  onConfirm: _noop,
  onClickOutSide: _noop
};